import {Typography} from "@mui/material";
import {MaterialSymbol, SymbolCodepoints} from "react-material-symbols";

enum RichTextType {
  TEXT,
  ICON,
}

type RichTextStyle = {
  fontWeight?: number;
  fontSize?: number | string;
  color?: string;
  opacity?: number;
  padding?: number | string;
};

type RichTextSegment = {
  style: RichTextStyle;
} & (
  | {
      type: RichTextType.TEXT;
      label: string;
    }
  | {
      type: RichTextType.ICON;
      label: SymbolCodepoints;
    }
);
export interface RichTextViewModel {
  segments: RichTextSegment[];
}

/** RICH TEXT CONVERSION */

/**
 * Converts a string to a RichTextViewModel
 * @param text - The string to convert
 * @param style - The style of the text
 * @returns A RichTextViewModel
 */
export function toRichText(
  data: {label: string; style?: RichTextStyle}[],
): RichTextViewModel {
  return {
    segments: data.map(({label: text, style}) => ({
      type: RichTextType.TEXT,
      label: text,
      style: {
        fontWeight: style?.fontWeight ?? 400,
        fontSize: style?.fontSize ?? "1rem",
        color: style?.color ?? "inherit",
        opacity: style?.opacity ?? 1,
        padding: style?.padding ?? 0,
      },
    })),
  };
}

/**
 * Converts a string to a RichTextViewModel
 * @param text - The string to convert
 * @param style - The style of the text
 * @returns A RichTextViewModel
 */
export function stringToRichText(
  text: string,
  style?: RichTextStyle,
): RichTextViewModel {
  return toRichText([{label: text, style}]);
}

export function iconToRichText(
  icon: SymbolCodepoints,
  style?: RichTextStyle,
): RichTextViewModel {
  return {
    segments: [{type: RichTextType.ICON, label: icon, style: style ?? {}}],
  };
}

/**
 * Converts a RichTextViewModel to a string
 * @param rt - The RichTextViewModel to convert
 * @returns A string
 */
export function getString(rt: RichTextViewModel) {
  return rt.segments
    .filter(segment => segment.type === RichTextType.TEXT)
    .map(segment => {
      return segment.label;
    })
    .join("");
}

/** RICH TEXT COMPONENT */
function RichTextSegment(props: RichTextSegment) {
  switch (props.type) {
    case RichTextType.TEXT:
      return (
        <Typography component="span" sx={props.style}>
          {props.label}
        </Typography>
      );
    case RichTextType.ICON:
      return (
        <Typography component="span" sx={props.style}>
          <MaterialSymbol icon={props.label} />
        </Typography>
      );
  }
}

export function RichText(props: RichTextViewModel) {
  return (
    <Typography
      sx={{display: "flex", flexDirection: "row", alignItems: "baseline"}}>
      {props.segments.map((segment, index) => {
        return <RichTextSegment key={index} {...segment} />;
      })}
    </Typography>
  );
}
